"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userflow = require("../../utils/userflow");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ToggleSwitchLabel = function ToggleSwitchLabel(_ref) {
  var isActive = _ref.isActive,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    onClick: isActive ? _userflow.preventEvent : undefined,
    className: className,
    isActive: isActive
  }, children);
};
ToggleSwitchLabel.defaultProps = {
  className: '',
  isActive: false
};
ToggleSwitchLabel.propTypes = {
  className: _propTypes["default"].string,
  isActive: _propTypes["default"].bool,
  children: _propTypes["default"].string.isRequired
};
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitchLabel__StyledLabel",
  componentId: "sc-5ilvm7-0"
})(["cursor:pointer;color:", ";font-size:14px;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackLight;
}, function (_ref3) {
  var isActive = _ref3.isActive,
    theme = _ref3.theme;
  return isActive && (0, _styledComponents.css)(["color:", ";cursor:default;"], theme.colors.black);
});
var _default = exports["default"] = ToggleSwitchLabel;